// extracted by mini-css-extract-plugin
module.exports = {"form_container":"form_form_container__3oY74 flex_column"};